export default () => ({
  isActive: false,
  isShow: false,
  isShowPrice: false,
  isShowProfile: false,
  covenants: [],
  profilePublic: [],
  graduations: {},
  companyProfileProfessionals: [],
  crm: null,
  uf: null,
  cnpj: null,
  professionalQRCodeURL: null,
  totalAgendas: null,
  totalProfessional: null,
  operatorCovenant: null,
  totalAgendaSchedules: null,
  loading: false,
  noProfilePublic: false,
  text: 'Aguarde Processando...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/gadget/resources/data.js